import ArticleMeta from '../types/ArticleMeta';

declare global {
  interface Window {
    dataLayer: object[];
  }
}

export function addEventToGTMDataLayer(event: object) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(event);
}

// Article card click related logic -->
export const articleCardLocation = {
  STAFF_PICKS: 'staff_picks',
  LATEST: 'latest',
  INCOMING: 'incoming',
  MAIN_CONTENT: 'main_content',
  NEWS: 'news',
  ARTICLE_FOOTER_RELATED: 'article_footer_related',
} as const;

export type ArticleCardLocation =
  (typeof articleCardLocation)[keyof typeof articleCardLocation];

export const articleCardClickTarget = {
  ARTICLE: 'article',
  AUTHOR: 'author',
  CATEGORY: 'category',
};

export type ArticleCardClickTargetType =
  (typeof articleCardClickTarget)[keyof typeof articleCardClickTarget];

/**
 *
 * @param articleMeta
 * @param target the click target area of the article click
 * @param location the location of the article card in the page
 * @param index the index of the article in the list, starting from 0
 */
export function sendArticleCardClickToGTM(
  articleMeta: ArticleMeta,
  target: ArticleCardClickTargetType,
  location?: ArticleCardLocation,
  index?: number,
) {
  addEventToGTMDataLayer({
    event: 'article_card_click',
    article_id: articleMeta.id,
    article_title: articleMeta.title,
    article_card_click_target: target,
    article_card_location: location,
    article_card_list_position: index ? index + 1 : undefined,
  });
}
